import React from 'react';

const SuccessMessage = ({ 
  title = "Success!", 
  message, 
  apiKey, 
  onContinue, 
  onGoToPricing, 
  onClose,
  showPricingButton = false,
  showLoginButton = false,
  showCloseButton = true
}) => {
  return (
    <div className="alert alert-success alert-dismissible fade show" role="alert">
      <div className="d-flex align-items-center">
        <i className="fas fa-check-circle text-success mr-3" style={{ fontSize: '1.5rem' }}></i>
        <div className="flex-grow-1">
          {title && <h5 className="alert-heading mb-1">{title}</h5>}
          {message && <p className="mb-0">{message}</p>}
         {/* {apiKey && (
            <div className="mt-2">
              <small className="text-muted">Your API Key: </small>
              <code className="bg-light px-2 py-1 rounded">{apiKey}</code>
            </div>
          )} */}
        </div>
      </div>
      
      <div className="mt-3">
        {showLoginButton && onContinue && (
          <button 
            className="btn btn-primary btn-sm mr-2" 
            onClick={onContinue}
          >
            Login
          </button>
        )}
        
        {showPricingButton && onGoToPricing && (
          <button 
            className="btn btn-outline-primary btn-sm mr-2" 
            onClick={onGoToPricing}
          >
            Choose a Plan
          </button>
        )}
        
        {showCloseButton && onClose && (
          <button 
            type="button" 
            className="btn btn-outline-success btn-sm" 
            onClick={onClose}
          >
            Close
          </button>
        )}
      </div>
    </div>
  );
};

export default SuccessMessage; 